import { Component, Prop, h, Host } from '@stencil/core';

@Component({
  tag: 'dda-event-card',
  styleUrls: [],
  shadow: false,
})
export class DdaEventCard {
  @Prop() card_header_text: string;
  @Prop() card_header_icon: string;
  @Prop() card_header_icon_id: string;

  @Prop() image_src: string;
  @Prop() event_month: string;
  @Prop() event_date: string;

  @Prop() header_text: string;
  @Prop() body_text: string;

  @Prop() custom_class?: string = '';
  @Prop() component_mode?: string;
  @Prop() clickHandler?: (event: MouseEvent) => void;

  @Prop({ mutable: true }) chip_list: {
    chip_text: string;
  }[] = [];

  @Prop({ mutable: true }) avatar_list: {
    src: string;
    aria_label?: string;
    button_id?: string;
    button_name?: string;
    dropdown_enabled?: boolean;
  }[] = [];

  componentWillRender() {
    const element = document.querySelector('dda-event-card') as HTMLElement;

    const chipAttr = element?.getAttribute('data-chip-list');
    if (chipAttr) {
      try {
        const parsed = JSON.parse(chipAttr);
        if (Array.isArray(parsed)) {
          this.chip_list = parsed;
        }
      } catch (e) {
        console.warn('Invalid chip_list JSON:', e);
      }
    }

    const avatarAttr = element?.getAttribute('data-avatar-list');
    if (avatarAttr) {
      try {
        const parsed = JSON.parse(avatarAttr);
        if (Array.isArray(parsed)) {
          this.avatar_list = parsed;
        }
      } catch (e) {
        console.warn('Invalid avatar_list JSON:', e);
      }
    }
  }

  render() {
    const cardClass = ['dda-card', this.custom_class].filter(Boolean).join(' ');
    

    return (
      <Host>
        <div
          class={cardClass}
          role="region"
          aria-label={this.header_text ? `Card: ${this.header_text}` : 'Information card'}
        >
          {this.card_header_text && (
            <div class="dda-card-header" role="heading" aria-level="2">
              <h6 class="h6 Regular" aria-label="Card header">{this.card_header_text}</h6>

              {this.card_header_icon && (
                <dda-button
                  button_color="onsurface-link"
                  icon_button_shape="circle"
                  start_icon={this.card_header_icon}
                  custom_class="dda-header-dots"
                  component_mode=""
                  button_id={this.card_header_icon_id}
                  aria_label="Card options menu"
                  onClick={() => console.log('clicked')}
                  button_name="Card menu"
                  size="md"
                  class="hydrated"
                ></dda-button>
              )}
            </div>
          )}

          {this.image_src && (
            <div class="dda-position-relative">
              <img
                src={this.image_src}
                class="dda-card-img"
                alt={this.header_text ? `${this.header_text} image` : 'Card image'}
              />
              <div class="dda-card-event-date" aria-label="Event date">
                <p class="caption Regular dda-m-0 dda-p-0" aria-label={`Month: ${this.event_month}`}>{this.event_month}</p>
                <h4 class="h4 Regular" aria-label={`Date: ${this.event_date}`}>{this.event_date}</h4>
              </div>
            </div>
          )}

          <div class="dda-card-body">
            <h5 class="h5 Regular" aria-label="Card title">{this.header_text}</h5>

            <p
              class="dda-card-text dda-d-flex dda-align-items-start dda-gap-2"
              aria-label="Card description"
            >
              {this.body_text}
            </p>

            <ul class="chips-container" aria-label="Tags">
              {this.chip_list.map((chip, index) => (
                <li key={index}>
                  <dda-chip
                    chip_text={chip.chip_text}
                    chip_icon="fiber_manual_record"
                    chip_icon_family="material-icons"
                    chip_icon_size="sm"
                    rounded="circle"
                    size="lg"
                    bg_color="grey"
                  ></dda-chip>
                </li>
              ))}
            </ul>

            {this.avatar_list?.some(avatar => avatar.src) && (
              <div
                class="avatar-container dda-d-flex dda-align-items-center dda-gap-3"
                role="group"
                aria-label="Assigned team members"
              >
                <ul class="dda-avatar-group dda-d-flex">
                  {this.avatar_list.map((avatar, index) => (
                    avatar.src && (
                      <li key={index}>
                        <dda-avatar
                          type="photo"
                          size="md"
                          design="default"
                          rounded="circle"
                          src={avatar.src}
                          aria_label={avatar.aria_label || `Team member ${index + 1}`}
                          button_id={avatar.button_id || ''}
                          button_name={avatar.button_name || ''}
                          dropdown_enabled={avatar.dropdown_enabled ?? false}
                        ></dda-avatar>
                      </li>
                    )
                  ))}
                </ul>

                <dda-button
                  button_color="default-tertiary"
                  icon_button_shape="default"
                  start_icon="add"
                  custom_class=""
                  component_mode=""
                  button_id="add-member-btn"
                  aria_label="Add team member"
                  button_name="Add"
                  button_shape="circle"
                  size="sm"
                >
                  <span class="visualy-hidden">Add team member</span>
                </dda-button>
              </div>
            )}
          </div>

          <div class="dda-card-footer">
            <a
              href="#"
              class="caption Regular dda-color-primary"
              role="link"
              aria-label={`Open ${this.header_text ? this.header_text : 'card'}`}
            >
              Open
            </a>
          </div>
        </div>
      </Host>
    );
  }
}
